export enum Brands{
    URocked = 1,
    PizzaHut = 2
}